import React, { useRef, useState, useEffect } from "react";
import Select, {SingleValue} from "react-select";
import {DatePicker, Table} from 'antd';
import type { ColumnsType } from 'antd/es/table'; // Import ColumnsType for type safety
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import TooltipOption from "../../../core/common/tooltipOption";
import { Button, Toast, ToastContainer } from 'react-bootstrap';
const BASE_URL = process.env.REACT_APP_BFF_URL;
// START Development By Ramesh ////
interface StudentSubjectAttend{
  admission_number: string;
  student_uid: number;
  status?: string; // Add attendance field
  attendance_date: string;
  subject: string;
  class_name: string;
  section_name: string;
  teacher_uid: number;
  attendance_remark: string;
  create_by: string;
  update_date: string;
  full_name: string;
  image_path: string;
}
interface TeacherSubjectInfo {
  "subject_name": string,
  "subject_id": number,
  "type": String
}

const StudentSubjectAttendance = ({ studentsClassAtt: initialStudentsClassAtt = [] }: { studentsClassAtt?: StudentSubjectAttend[] }) => {
  const routes = all_routes;

   const [studentsClassAtt, setStudentsClassAtt] = useState<StudentSubjectAttend[]>(initialStudentsClassAtt);
   const [checkAttendanceExists, setCheckAttendanceExists] = useState<boolean | null>(null);
   const [isEditable, setIsEditable] = useState(false); // Track edit mode

  // Get Student Data From BFF
  const [classId, setClassId] = useState('Year 1');
  const [sectionId, setSectionId] = useState('Jupiter');
  const [todayDt, setTodayDt] = useState(new Date().toISOString().split('T')[0]); // Store today's date

  const [attendanceStatus, setAttendanceStatus] = useState<{ [key: number]: string }>({});
  const [attendanceRemarks, setAttendanceRemarks] = useState<{ [key: number]: string }>({});
  const [teacherDetails, setTeacherDetails] = useState([]);
  const [fetchSubjectInfo, setFetchSubjectInfo] = useState([]);
  const [selectedTeacher, setSelectedTeacher] =  useState(1);
  const [selectedSubjects, setSelectedSubjects] = useState('');
  const [selectedClasses, setSelectedClasses] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [isError, setIsError] = useState(false);


  useEffect(() => {
    const fetchTeacherDetails = async () => {
      try {
        const response = await fetch('/api/teacher/getTeacherByTeacherName');
        const dataJson = await response.json();
        setTeacherDetails(dataJson);
        console.log('Fetch DATA from BFF111111111 =>: ',dataJson);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  fetchTeacherDetails();
 } , []);

  const handleSubjectsChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setSelectedSubjects(selectedOption ? selectedOption.value : '');
  };

  const handleClassesChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setSelectedClasses(selectedOption ? selectedOption.label : '');
  };

  const handleSectionsChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setSelectedSection(selectedOption ? selectedOption.label : '');
  };
  const handleTeacherNameChange = (selectedOption: SingleValue<{ label: string; value: number }>) => {
    console.log('Selected Teacher:', selectedOption);
    let teacherId:any = selectedOption?.value;
    setSelectedTeacher(teacherId);

    const fetchSubjectInfo = async () => {
    try {
      const response : Response = await fetch('/api/teacher/getTeacherBySubjects/'+teacherId);
      response.json().then(dataJson => {
        setFetchSubjectInfo(dataJson);
      })
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  fetchSubjectInfo();
  };

  // Handle radio button change
  const handleAttendanceChange = (studentUid: number, status: string) => {
    if (!isEditable) return; // Prevent editing when not in edit mode

    setAttendanceStatus((prevStatus) => ({
      ...prevStatus,
      [studentUid]: status,
    }));

    setStudentsClassAtt((prevStudents) =>
      prevStudents.map((student) =>
        student.student_uid === studentUid ? { ...student, status: status } : student
      )
    );
  };

  const handleRemarkChange = (studentUid: number, value: string) => {
    if (!isEditable) return;

    setAttendanceRemarks((prevRemarks) => ({
      ...prevRemarks,
      [studentUid]: value,
    }));

    setStudentsClassAtt((prevStudents) =>
      prevStudents.map((student) =>
        student.student_uid === studentUid ? { ...student, attendance_remark: value } : student
      )
    );
  };

  const handleEditAttendance = () => {
    setIsEditable(true); // Enable fields for editing
  };


  const handleUpdateAttendance = async () => {
    const updatedStudents = studentsClassAtt.map(student => ({
      ...student,
      status: attendanceStatus[student.student_uid],
      attendance_date: new Date().toISOString().split('T')[0], // Update attend status where by today's date
      attendance_remark: attendanceRemarks[student.student_uid],
      update_by: 'Admin',
      update_date: new Date().toISOString().split('T')[0],
    }));
    try {
      const response = await fetch('/api/studentSubjectAttend/updateStudentSubjectAttend', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedStudents),
      });

      const result = await response.json();
      console.log('Update result:', result);

      if (response.ok) {
        setCheckAttendanceExists(true);
        setIsEditable(false);
        setToastMessage('Attendance updated successfully!');
        setIsError(false);
      } else {
        setToastMessage(result.message || 'Failed to save attendance');
        setIsError(true);
      }
      setShowToast(true); // Show toast
    } catch (error) {
      console.error('Error saving attendance:', error);
      setToastMessage('An error occurred while saving attendance');
      setIsError(true);
      setShowToast(true); // Show toast
    }
  };
  const data = studentsClassAtt;

  const handleSaveAttendance = async () => {
    let teacher = selectedTeacher;
    const studentsWithAttendance = studentsClassAtt.map(student => ({
      ...student,
      status: attendanceStatus[student.student_uid] || 'Present',
      attendance_date: new Date().toISOString().split('T')[0], // Assuming you want to use today's date
      subject: "English",
      teacher_uid: teacher, // Replace with actual teacher_uid
      create_by: 'Admin', // Replace with actual create_by
      update_by: 'Admin', // Replace with actual update_by
      update_date: new Date().toISOString().split('T')[0], // Assuming you want to use today's date
    }));
    try {
      const response = await fetch('/api/studentSubjectAttend/addStudentSubjectAttend', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(studentsWithAttendance),
      });
      console.log('THE DATA TO SAVE IN DB:', studentsWithAttendance);
      const result = await response.json();
      console.log('Save attendance result:', result);

      if (response.ok) {
        setCheckAttendanceExists(true);
        setIsEditable(false); // Disable editing mode after saving
        setToastMessage('Attendance save successfully!');
        setIsError(false);
      }
    } catch (error) {
      console.error('Error saving attendance:', error);
      setToastMessage('An error occurred while saving attendance');
      setIsError(true);
      setShowToast(true); // Show toast
    }
    setShowToast(true); // Show toast
  };

  // end Development By Loges ////
  const [selectedOptions, setSelectedOptions] = useState(
    data.map(() => "Present") // Default to 'Present' for each row
  );

  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }

    const fetchStudentClassSection = async () => {
      try {
        let classId = selectedClasses;
        let sectionId = selectedSection;
        const response = await fetch(`/api/studentSubjectAttend/getStudentBySubjectSection/${classId}/${sectionId}`);
        const dataJson = await response.json();
        console.log('Fetch DATA from BFF: ',dataJson);
        setStudentsClassAtt(dataJson);

        // Populate attendanceStatus & attendanceRemarks from DB
        const statusMap = dataJson.reduce((acc: { [key: number]: string }, student: StudentSubjectAttend) => {
          acc[student.student_uid] = student.status || '';
          return acc;
        }, {});
        setAttendanceStatus(statusMap);

        const remarksMap = dataJson.reduce((acc: { [key: number]: string }, student: StudentSubjectAttend) => {
          acc[student.student_uid] = student.attendance_remark || '';
          return acc;
        }, {});
        setAttendanceRemarks(remarksMap);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchStudentClassSection();

    // Check if attendance exists for today's date
      const checkAttendance = async () => {
        try {
          let classId = selectedClasses;
          let sectionId = selectedSection;
          const response = await fetch(`/api/studentSubjectAttend/checkAttendanceExists/${classId}/${sectionId}/${todayDt}`);
          const data = await response.json();
          console.log("Attendance exists response:", data);
          if (data && typeof data.attendanceExists !== "undefined") {
            setCheckAttendanceExists(data.attendanceExists);
            setIsEditable(!data.attendanceExists); // If records exist, disable editing
          } else {
            console.error("Invalid API response format:", data);
          }
        } catch (error) {
          console.error("Error checking attendance:", error);
        }
      };
      checkAttendance();
  };
  // Handle state change for each row


  const columns: ColumnsType<StudentSubjectAttend> = [
    {
      title: "Admission No",
      dataIndex: "admission_number",
      render: (text: string, student: StudentSubjectAttend) => (
        <span>{student.admission_number}</span>
      ),
    },
    {
      title: "Name",
      dataIndex: "full_name",
      render: (text: string, student: StudentSubjectAttend) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <img
              // src={`http://localhost:3005/api/studentClassAttend/uploads/479122d69423ca4c245b5d680ad47c08`}
              src={`${BASE_URL}/api/studentClassAttend${student.image_path}`}
              className="img-fluid rounded-circle"
              alt="upload file"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
            <span>{student.full_name}</span>
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Class",
      dataIndex: "class_name",
    },
    {
      title: "Section",
      dataIndex: "section_name",
    },

    {
      title: 'Attendance',
      dataIndex: 'attendance',
      render: (text: string, student: any) => (
        <div className="d-flex align-items-center check-radio-group flex-nowrap">
          {['Present', 'Late', 'Absent', 'Holiday', 'Medical Leave'].map((status) => (
            <label key={status} className="custom-radio">
              <input
                type="radio"
                name={`student${student.student_uid}`}
                value={status}
                checked={attendanceStatus[student.student_uid] === status}
                onChange={(e) => handleAttendanceChange(student.student_uid, e.target.value)}
                disabled={!isEditable} // Disable radio buttons if not in edit mode
              />
              <span className="checkmark" />
              {status}
            </label>
          ))}
        </div>
      ),
    },
    {
      title: 'Notes',
      dataIndex: 'notes',
      render: (_, student) => (
        <input
          type="text"
          className="form-control"
          placeholder="Enter Notes"
          value={attendanceRemarks[student.student_uid]}
          onChange={(e) => handleRemarkChange(student.student_uid, e.target.value)}
          disabled={!isEditable} // Disable input if not in edit mode
        />
      ),
    },
  ];
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Student Attendance</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Report</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Student Attendance
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption/>
            </div>
          </div>
          {/* /Page Header */}
          {/* Search Teacher and section */}
          <div className="card">
            <div className="card-header bg-light">
              <div className="d-flex align-items-center">
                  <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-map fs-16"/>
                  </span>
                <h4 className="text-dark">Student Subject Attendance</h4>
              </div>
            </div>
            <form>
              <div className="card-body pb-1">
                <div className="row">
                  <div className="col-xxl col-xl-3 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Teacher Name</label>
                      <Select
                          className="select"
                          options={teacherDetails.map((teacher: any) => ({
                            label: teacher.full_name + ' - ' + teacher.teacher_id,
                            value: teacher.teacher_uid,
                            teacher_id: teacher.teacher_id
                          }))}
                          onChange={handleTeacherNameChange}
                          placeholder="Select Teacher"
                      />
                    </div>
                  </div>

                  <div className="col-xxl col-xl-3 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Subjects</label>
                      <Select
                          className="select"
                          options={fetchSubjectInfo
                              .filter((subject: any) => subject.type === 'subject') // Filter subjects by teacher_name
                              .map((subject: any) => ({
                                label: subject.subject_name,
                                value: subject.subject_id,
                              }))
                          }
                          placeholder="Select Subjects"
                          onChange={handleSubjectsChange}
                      />
                    </div>
                  </div>
                  <div className="col-xxl col-xl-3 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">class</label>
                      <Select
                          className="select"
                          options={fetchSubjectInfo
                              .filter((subject: any) => subject.type === 'class') // Filter subjects by teacher_name
                              .map((subject: any) => ({
                                label: subject.subject_name,
                                value: subject.subject_id,
                              }))
                          }
                          placeholder="Select Class"
                          onChange={handleClassesChange}
                      />
                    </div>
                  </div>
                  <div className="col-xxl col-xl-3 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Section</label>
                      <Select
                          className="select"
                          options={fetchSubjectInfo
                              .filter((subject: any) => subject.type === 'section') // Filter by 'section'
                              .flatMap((subject: any) =>
                                  subject.subject_name.split(',').map((name: string) => ({
                                    label: name.trim(), // Trim spaces around the name
                                    value: subject.subject_id ? subject.subject_id.split(',') : [], // Safely handle subject_id
                                  }))
                              )
                          }
                          placeholder="Select Section"
                          onChange={handleSectionsChange}
                      />
                    </div>
                  </div>

                </div>
                <div className="text-end">
                  <button type="button" className="btn btn-primary me-3" onClick={handleApplyClick}>Search Student</button>
                </div>
              </div>
            </form>
            {/* Toast Notification */}
            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
              <Toast
                  show={showToast}
                  onClose={() => setShowToast(false)}
                  delay={3000}
                  autohide
                  bg={isError ? 'danger' : 'success'}
              >
                <Toast.Header>
                  <strong className="me-auto">
                    {isError ? 'Error' : 'Success'}
                  </strong>
                </Toast.Header>
                <Toast.Body className="text-white">
                  {toastMessage}
                </Toast.Body>
              </Toast>
            </ToastContainer>
          </div>

          {/* Search Teacher and section */}

          {/* Student List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3"></h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="dropdown mb-3 me-2">

                </div>
                <div className="dropdown mb-3">
                  <Link
                      to="#"
                      className="btn btn-outline-light bg-white dropdown-toggle"
                      data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-sort-ascending-2 me-2"/>
                    Sort by A-Z
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1 active">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Viewed
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}
              <Table dataSource={data} columns={columns} rowKey="student_uid"/>
              {/* /Student List */}
            </div>
            <div className="card-footer text-end">
              {!checkAttendanceExists ? ( // If no attendance records, show Save Attendance
                  <button className="btn btn-primary" onClick={handleSaveAttendance}>
                    Save Attendance
                  </button>
              ) : (
                  <>
                    {!isEditable ? (
                        <button className="btn btn-secondary" id="successToastBtn" onClick={handleEditAttendance}>
                          Edit Attendance
                        </button>
                    ) : (
                        <button className="btn btn-primary" onClick={handleUpdateAttendance}>
                          Update Attendance
                        </button>
                    )}
                  </>
              )}
            </div>


          </div>
          {/* /Student List */}
        </div>
      </div>
    </div>
  );
};

//export default StudentAttendance;
export default StudentSubjectAttendance;
